(function(window, undefined) {
    
      'use strict';
    
      var AudioPlayer = (function() {
    
        // Player vars!
        var
        docTitle = document.title,
        player   = document.getElementById('ap'),
        playBtn,
        prevBtn,
        nextBtn,
        plRadioBtn,
        plRadioBtnBis,
        volumeOpened,
        volumeBtn,
        trackCover,
        trackTitle,
        audio,
        index = 0,
        playList,
        volumeBar,
        wheelVolumeValue = 0,
        volumeLength,
        seeking = false,
        seekingVol = false,
        rightClick = false,
        apActive = false,
        // playlist vars
        pl,
        plUl,
        plLi,
        tplList =
                  '<li class="pl-list" data-track="{count}">'+
                    '<div class="pl-list__track">'+
                      '<div class="media__object">'+
                        '<div class="media__cover">'+
                          '<div class="media__cover__item" style="background-image: url({icon});"></div>'+
                        '</div>'+
                      '</div>'+
                      '<div class="track">'+
                        '<a href="#!">'+
                          '<div class="track__cover">'+
                            '<div style="background-image: url(../assets/img/exemple-album.jpg);"></div>'+
                            // '<div class="pl-list__icon"></div>'+
                            '<div class="pl-list__eq">'+
                              '<div class="eq">'+
                                '<div class="eq__bar"></div>'+
                                '<div class="eq__bar"></div>'+
                                '<div class="eq__bar"></div>'+
                                '<div class="eq__bar"></div>'+
                              '</div>'+
                            '</div>'+
                          '</div>'+
                        '</a>'+
                        '<div class="track-info">'+
                          '<div class="track-info__radio">{title}</div>'+
                          '<div class="track-info__title">I’M Better (feat.Lamb)</div>'+
                          '<div class="track-info__artist">Missy Elliott</div>'+
                        '</div>'+
                      '</div>'+
                    '</div>'+
                  '</li>',
        // settings
        settings = {
          volume        : 0.35,
          changeDocTitle: true,
          autoPlay      : false,
          buffered      : false,
          notification  : false,
          playList      : []
        };
    
        function init(options) {
    
          if (!('classList' in document.documentElement)) {
            return false;
          }
    
          if (apActive || player === null) {
            return 'Player already init';
          }
    
          settings = extend(settings, options);
    
          // get player elements
          playBtn        = player.querySelector('.ap__controls--toggle');
          prevBtn        = document.querySelector('.ap__controls--prev');
          nextBtn        = document.querySelector('.ap__controls--next');
          plRadioBtn     = player.querySelector('.ap__controls--playlist');
          plRadioBtnBis  = document.querySelector('.ap__inner--middle .ap__controls--playlist');
          trackCover     = player.querySelector('.track__cover-art__img');
          trackTitle     = player.querySelector('.track-info__radio');
    
          playList = settings.playList;
    
          playBtn.addEventListener('click', playToggle, false);
    
          document.documentElement.addEventListener('mouseup', seekingFalse, false);
          
          if (prevBtn) {
            prevBtn.addEventListener('click', prev, false);
          }

          if (nextBtn) {
            nextBtn.addEventListener('click', next, false);
          }

          apActive = true;
    
          // Create playlist
          renderPL();
    
          $('.owl-carousel').owlCarousel({
            center: false,
            loop: false,
            nav: false,
            dots: false,
            margin: 0,
            autoWidth: true,
            responsive : {
            // breakpoint from 768 up
              992 : {
                margin: 20,
              }
            }
          });
    
          plRadioBtn.addEventListener('click', plToggle, false)
          plRadioBtnBis.addEventListener('click', plToggle, false)
    
          var btnClosePlaylist = document.querySelector('.pl-top .ap__controls--playlist')
    
          btnClosePlaylist.addEventListener('click', function() {
            this.parentNode.parentNode.classList.toggle('h-show')
    
            if ($('.pl-container').hasClass('h-show')) {
              $('.ap__controls--prev').addClass('hide')
              $('.ap__controls--next').addClass('hide')
            } else {
              $('.ap__controls--prev').removeClass('hide')
              $('.ap__controls--next').removeClass('hide')
            }
          })
    
          // Create audio object
          audio = new Audio();
          audio.volume = settings.volume;
          audio.preload = 'auto';
    
          audio.addEventListener('error', errorHandler, false);
          audio.addEventListener('ended', doEnd, false);
          audio.addEventListener('ended', doEnd, false);
    
          if (isEmptyList()) {
            return false;
          }
    
          audio.src = playList[index].file;
          trackTitle.innerHTML = playList[index].title;
          console.log(trackTitle)
    
          if (settings.autoPlay) {
            playBtn.classList.add('is-playing');
    
            audio.play();
    
            playBtn.classList.add('is-loading');
    
            plLi[index].classList.add('pl-list--current');
            notify(playList[index].title, {
              icon: playList[index].icon,
              body: 'Now playing'
            });
          }
        }
    
        function changeDocumentTitle(title) {
          if (settings.changeDocTitle) {
            if (title) {
              document.title = title;
            }
            else {
              document.title = docTitle;
            }
          }
        }
    
        function beforeUnload(evt) {
          if (!audio.paused) {
            var message = 'Music still playing';
            evt.returnValue = message;
            return message;
          }
        }
    
        function errorHandler(evt) {
          if (isEmptyList()) {
            return;
          }
          var mediaError = {
            '1': 'MEDIA_ERR_ABORTED',
            '2': 'MEDIA_ERR_NETWORK',
            '3': 'MEDIA_ERR_DECODE',
            '4': 'MEDIA_ERR_SRC_NOT_SUPPORTED'
          };
          audio.pause();
          playBtn.classList.remove('is-playing');
          plLi[index] && plLi[index].classList.remove('pl-list--current');
          changeDocumentTitle();
          throw new Error('Houston we have a problem: ' + mediaError[evt.target.error.code]);
        }
    
      /**
       *  PlayList methods
       */
        function renderPL() {
          var html = [];
    
          playList.forEach(function(item, i) {
            html.push(
              tplList.replace('{count}', i).replace('{title}', item.title).replace('{icon}', item.icon)
            );
          });
    
          pl = create('div', {
            'className': 'pl-container',
            'id': 'pl',
            'innerHTML': '<div class="pl-top">'+
                            '<span class="pl-top__count">' +
                              '14 Stations'+
                            '</span>'+
                            '<button class="ap__controls--playlist">'+
                              '<svg class="icon icon--cross">'+
                                '<use xlink:href="assets/icons.svg#cross"></use>'+
                              '</svg>'+
                            '</button>'+
                          '</div>'+
                          '<ul class="pl-ul owl-carousel">' + (!isEmptyList() ? html.join('') : '<li class="pl-list--empty">Aucune radio disponible...</li>') + '</ul>'
          });
    
          player.parentNode.insertBefore(pl, player.nextSibling);
    
          plUl = pl.querySelector('.pl-ul');
          plLi = plUl.querySelectorAll('li');
    
          pl.addEventListener('click', listHandler, false);
        }
    
        function listHandler(evt) {
          evt.preventDefault();
    
          if (evt.target.closest('.pl-list__title') || evt.target.closest('.pl-list__track')) {
            var current = parseInt(evt.target.closest('.pl-list').getAttribute('data-track'), 10);
            if (index !== current) {
              index = current;
              play(current);
            }
            else {
              playToggle();
            }
          } else {
            if (!!evt.target.closest('.pl-list__remove')) {
              var parentEl = evt.target.closest('.pl-list');
              var isDel = parseInt(parentEl.getAttribute('data-track'), 10);
    
              playList.splice(isDel, 1);
              parentEl.closest('.pl-ul').removeChild(parentEl);
    
              plLi = pl.querySelectorAll('li');
    
              [].forEach.call(plLi, function(el, i) {
                el.setAttribute('data-track', i);
              });
    
              if (!audio.paused) {
    
                if (isDel === index) {
                  play(index);
                }
    
              }
              else {
                if (isEmptyList()) {
                  clearAll();
                } else {
                  if (isDel === index) {
                    if (isDel > playList.length - 1) {
                      index -= 1;
                    }
                    audio.src = playList[index].file;
                    trackCover.innerHTML = playList[index].icon;
                    trackTitle.innerHTML = playList[index].title;
                  }
                }
              }
              if (isDel < index) {
                index--;
              }
            }
          }
        }
    
        function plActive() {
          if (audio.paused) {
            plLi[index].classList.remove('pl-list--current');
            return;
          }
          var current = index;
          for(var i = 0, len = plLi.length; len > i; i++) {
            plLi[i].classList.remove('pl-list--current');
          }
          plLi[current].classList.add('pl-list--current');
        }
    
    
      /**
       * Player methods
       */
        function play(currentIndex) {
    
          if (isEmptyList()) {
            return clearAll();
          }
    
          index = (currentIndex + playList.length) % playList.length;
    
          audio.src = playList[index].file;
          trackTitle.innerHTML = playList[index].title;
    
          // Change document title
          changeDocumentTitle(playList[index].title);
    
          audio.play();
    
          // Show notification
          notify(playList[index].title, {
            icon: playList[index].icon,
            body: 'Now playing',
            tag: 'music-player'
          });
    
          // Toggle play button
          playBtn.classList.add('is-playing');
    
          // Set active song playlist
          plActive();
        }
    
        function prev() {
          play(index - 1);
          console.log('avant')
        }
    
        function next() {
          play(index + 1);
          console.log('après')
        }
    
        function isEmptyList() {
          return playList.length === 0;
        }
    
        function clearAll() {
          audio.pause();
          audio.src = '';
          trackTitle.innerHTML = 'queue is empty';
          playBtn.classList.remove('is-playing');
          if (!plUl.querySelector('.pl-list--empty')) {
            plUl.innerHTML = '<li class="pl-list--empty">Aucune radio disponible</li>';
          }
          changeDocumentTitle();
        }
    
        function playToggle() {
          if (isEmptyList()) {
            return;
          }
    
          if (audio.paused) {
            if (audio.currentTime === 0) {
              notify(playList[index].title, {
                icon: playList[index].icon,
                body: 'Now playing'
              });
            }
            changeDocumentTitle(playList[index].title);
    
            audio.play();
    
            playBtn.classList.add('is-playing');
            //playSvgPath.setAttribute('d', playSvg.getAttribute('data-pause'));
          }
          else {
            changeDocumentTitle();
            audio.pause();
            playBtn.classList.remove('is-playing');
            //playSvgPath.setAttribute('d', playSvg.getAttribute('data-play'));
          }
    
          plActive();
        }
    
        function plToggle(e) {
          pl.classList.toggle('h-show');
          document.querySelector('.ap__controls--playlist .track-info__radio').classList.toggle('reverse')
    
          if ($('.pl-container').hasClass('h-show')) {
            $('.ap__controls--prev').addClass('hide')
            $('.ap__controls--next').addClass('hide')
          } else {
            $('.ap__controls--prev').removeClass('hide')
            $('.ap__controls--next').removeClass('hide')
          }
        }
    
        function doEnd() {
          play(index + 1);
        }
    
      function seek(evt) {
        evt.preventDefault();
        if(seeking && rightClick === false && audio.readyState !== 0) {
          window.value = moveBar(evt, progressBar, 'horizontal');
        }
      }
    
      function seekingFalse() {
        if(seeking && rightClick === false && audio.readyState !== 0) {
          audio.currentTime = audio.duration * (window.value / 100);
        }
        seeking = false;
        seekingVol = false;
      }
    
      function notify(title, attr) {
        if (!settings.notification) {
          return;
        }
        if (window.Notification === undefined) {
          return;
        }
        attr.tag = 'AP music player';
        window.Notification.requestPermission(function(access) {
          if (access === 'granted') {
            var notice = new Notification(title.substr(0, 110), attr);
            setTimeout(notice.close.bind(notice), 5000);
          }
        });
      }
    
      /**
       *  Helpers
       */
        function wheel() {
          var wheel;
          if ('onwheel' in document) {
            wheel = 'wheel';
          } else if ('onmousewheel' in document) {
            wheel = 'mousewheel';
          } else {
            wheel = 'MozMousePixelScroll';
          }
          return wheel;
        }
    
        function extend(defaults, options) {
          for(var name in options) {
            if (defaults.hasOwnProperty(name)) {
              defaults[name] = options[name];
            }
          }
          return defaults;
        }
        function create(el, attr) {
          var element = document.createElement(el);
          if (attr) {
            for(var name in attr) {
              if (element[name] !== undefined) {
                element[name] = attr[name];
              }
            }
          }
          return element;
        }
    
        Element.prototype.offset = function() {
          var el = this.getBoundingClientRect(),
          scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
          return {
            top: el.top + scrollTop,
            left: el.left + scrollLeft
          };
        };
    
        Element.prototype.css = function(attr) {
          if (typeof attr === 'string') {
            return getComputedStyle(this, '')[attr];
          }
          else if (typeof attr === 'object') {
            for(var name in attr) {
              if (this.style[name] !== undefined) {
                this.style[name] = attr[name];
              }
            }
          }
        };
    
        // matches polyfill
        window.Element && function(ElementPrototype) {
            ElementPrototype.matches = ElementPrototype.matches ||
            ElementPrototype.matchesSelector ||
            ElementPrototype.webkitMatchesSelector ||
            ElementPrototype.msMatchesSelector ||
            function(selector) {
                var node = this, nodes = (node.parentNode || node.document).querySelectorAll(selector), i = -1;
                while (nodes[++i] && nodes[i] != node);
                return !!nodes[i];
            };
        }(Element.prototype);
    
        // closest polyfill
        window.Element && function(ElementPrototype) {
            ElementPrototype.closest = ElementPrototype.closest ||
            function(selector) {
                var el = this;
                while (el.matches && !el.matches(selector)) el = el.parentNode;
                return el.matches ? el : null;
            };
        }(Element.prototype);
    
      /**
       *  Public methods
       */
        return {
          init: init,
        };
    
      })();
    
      window.AP = AudioPlayer;
    
      })(window);
    
      AP.init({
        playList: [
          {'icon': 'assets/img/boomers/musicstation.jpg', 'title': 'Legends', 'file': 'http://stream.myjungly.fr:8000/MYJUNGLY'},
          {'icon': 'assets/img/boomers/alternativ.jpg', 'title': 'Alternativ', 'file': 'http://stream.myjungly.fr:8000/LEGENDS'},
          {'icon': 'assets/img/boomers/hiphop.jpg', 'title': 'Hip Hop Radio', 'file': 'http://stream.myjungly.fr:8000/HITS'},
          {'icon': 'assets/img/boomers/legends.jpg', 'title': 'Legends', 'file': 'http://stream.myjungly.fr/ELECTRO'},
          {'icon': 'assets/img/boomers/hits.jpg', 'title': 'Hits', 'file': 'http://stream.myjungly.fr/LOUNGE'},
          {'icon': 'assets/img/boomers/electro.jpg', 'title': 'Electro Station', 'file': 'http://stream.myjungly.fr/ELECTRO'},
        ]
      });